var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61 15.47L7.14 13.38L9.23 12.86L7.14 12.34L6.61 10.25L6.09 12.34L4 12.86L6.09 13.38L6.61 15.47Z",
    fill: "#19838C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12L16.5657 8.55556L20 7L16.5657 5.45455L15 2L13.4647 5.45455L10 7L13.4647 8.55556L15 12Z",
    fill: "#19838C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 22.21L14.92 20.92L16.2 20.6L14.92 20.28L14.6 19L14.28 20.28L13 20.6L14.28 20.92L14.6 22.21Z",
    fill: "#19838C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new-icon.09d74ad56b9373ff337d693571949ac7.svg";
export { ForwardRef as ReactComponent };